import React from 'react'
import styled from 'styled-components'
import IconControl from '../controls/icon-control'
import TextButton from './text-button'

const ArrowIconSpan = styled.span`
  margin-left: -11px;
`

const LabelSpan = styled.span`
  margin-left: 10px;
`

interface IProps {
  label: string
  fontSize?: string
  onClick: any
  disabled?: boolean
}

class BackButton extends React.Component<IProps> {
  render() {
    const { label, ...textButtonProps } = this.props
    return (
      <TextButton {...textButtonProps}>
        <ArrowIconSpan>
          <IconControl icon="arrow-left" style={{ fontSize: '14px' }} />
        </ArrowIconSpan>
        <LabelSpan>{label}</LabelSpan>
      </TextButton>
    )
  }
}

export default BackButton
